import * as React from 'react';

import { ProjectDiagramCreateClassDrawer } from 'src/containers/ProjectDiagram/components/classDrawer/ProjectDiagramCreateClassDrawer';
import { CreateMappingDialog } from 'src/containers/ProjectDiagram/components/dialogs/CreateMappingDialog';
import { ProjectDiagramCreateRelationshipDrawer } from 'src/containers/ProjectDiagram/components/relationshipDrawer/ProjectDiagramCreateRelationshipDrawer';
import { ProjectDiagramCreateSensitivePropertyGroupDrawer } from 'src/containers/ProjectDiagram/components/sensitivePropertyGroupDrawer/ProjectDiagramCreateSensitivePropertyGroupDrawer';
import { ProjectFileUploadPreviewDialog } from 'src/containers/ProjectFileUploadPreviewDialog/ProjectFileUploadPreviewDialog';
import { ProjectMappingSettingsDrawer } from 'src/containers/ProjectMappingSettingsDrawer/ProjectMappingSettingsDrawer';
import { ProjectModelDialog } from 'src/containers/ProjectModelDialog/ProjectModelDialog';
import { RenameProjectModelDialog } from 'src/containers/ProjectModelDialog/RenameProjectModelDialog';
import { ProjectNewResourceDialog } from 'src/containers/ProjectNewResourceDialog/ProjectNewResourceDialog';
import { ProjectResourceSuggestionsDialog } from 'src/containers/ProjectResourceSuggestionsDialog/ProjectResourceSuggestionsDialog';
import { ProjectRuleDetailDrawer } from 'src/containers/ProjectRuleDetailDrawer/ProjectRuleDetailDrawer';
import { ProjectSettingsDrawer } from 'src/containers/ProjectSettingsDrawer/ProjectSettingsDrawer';
import { ProjectVirtualGraphPreviewDialog } from 'src/containers/ProjectVirtualGraphPreviewDialog/ProjectVirtualGraphPreviewDialog';
import { PublishProjectDrawer } from 'src/containers/PublishProjectDrawer/PublishProjectDrawer';
import { useDelayedUnmount } from 'src/utils/hooks/useDelayedUnmount';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const ProjectOverlays: React.VFC = () => {
  const isCreateClassDrawerOpen = useReduxSelector(
    (state) => state.ui.createClassDrawer.isOpen
  );
  const isCreateRelationshipDrawerOpen = useReduxSelector(
    (state) => state.ui.createRelationshipDrawer.isOpen
  );
  const isCreateSensitivePropertyGroupDrawerOpen = useReduxSelector(
    (state) => state.ui.createSensitivePropertyGroupDrawer.isOpen
  );
  const isCreateMappingDialogOpen = useReduxSelector(
    (state) => state.ui.createMappingDialog.isOpen
  );
  const isResourceSuggestionsDialogOpen = useReduxSelector(
    (state) => state.ui.resourceSuggestionsDialog.isOpen
  );

  const shouldRenderCreateClassDrawer = useDelayedUnmount(
    isCreateClassDrawerOpen
  );
  const shouldRenderCreateRelationshipDrawer = useDelayedUnmount(
    isCreateRelationshipDrawerOpen
  );
  const shouldRenderCreateSensitivePropertyGroupDrawer = useDelayedUnmount(
    isCreateSensitivePropertyGroupDrawerOpen
  );
  const shouldRenderCreateMappingDialog = useDelayedUnmount(
    isCreateMappingDialogOpen
  );
  const shouldRenderResourceSuggestionsDialog = useDelayedUnmount(
    isResourceSuggestionsDialogOpen
  );

  return (
    <>
      {shouldRenderCreateClassDrawer ? (
        <ProjectDiagramCreateClassDrawer />
      ) : null}
      {shouldRenderCreateRelationshipDrawer ? (
        <ProjectDiagramCreateRelationshipDrawer />
      ) : null}
      {shouldRenderCreateSensitivePropertyGroupDrawer ? (
        <ProjectDiagramCreateSensitivePropertyGroupDrawer />
      ) : null}

      <ProjectRuleDetailDrawer />

      <ProjectMappingSettingsDrawer />
      <ProjectSettingsDrawer />
      <PublishProjectDrawer />

      <ProjectModelDialog />
      <RenameProjectModelDialog />
      <ProjectNewResourceDialog />
      <ProjectFileUploadPreviewDialog />
      <ProjectVirtualGraphPreviewDialog />

      {shouldRenderCreateMappingDialog ? <CreateMappingDialog /> : null}
      {shouldRenderResourceSuggestionsDialog ? (
        <ProjectResourceSuggestionsDialog />
      ) : null}
    </>
  );
};
